import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import FileUpload from './FileUpload'
import Modal from './Modal'
import { ImportSocieties } from '../graphql/mutations'

const ImportSocietyModal = ({
    show,
    close,
    onSuccess,
}) => {

    const { t } = useTranslation()
    const [error, setError] = useState()
    const [loading, setLoading] = useState(false)
    const [importSocieties] = useMutation(ImportSocieties)

    const handleImport = async (file) => {
        setLoading(true)
        
        try {
            const res = await importSocieties({
                variables: {
                    file,
                },
            })

            if (!res?.data?.importSocieties || res.data.importSocieties.code === 'FAIL') {
                if (res.data.importSocieties.items?.length > 0) {
                    const failList = res.data.importSocieties.items.map(x => `Name: ${x.name}, Code: ${x.code}, Country: ${x.country}`)
                    setError(`${t('societies.add_error')}\n\n${failList.join('\n')}`)
                    return
                }
                setError(t('societies.add_error'))
                return
            }

            if (onSuccess) onSuccess()
        } catch (err) {
            setError(t('societies.add_error'))
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    const handleClose = () => {
        if (close) close()
        setError(null)
    }

    return (
        <Modal
            className={'modal-society'}
            show={show}
            close={handleClose}
            title={ t('societies.import') }
        >
            <FileUpload
                handleUpload={handleImport}
                loading={loading}
            />

            {
                error ?
                <div className='error-message'>
                    <span>{ error }</span>
                </div>
                :
                <></>
            }
        </Modal>
    )
}

export default ImportSocietyModal